import type { AnalyticEvent } from '@twisto/utils'
import { ANALYTICS_EVENTS, events } from '@twisto/utils'

import { routes } from '../../routes'

export const flowPageVisitConfig: (
  session: string
) => Map<string, AnalyticEvent> = (sessionId) =>
  new Map<string, AnalyticEvent>([
    [
      routes.step.czBasicAccountAgreements.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.REGISTRATION_CONSENTS_SCREEN_VIEW](),
    ],
    [
      routes.step.plBasicAccountAgreements.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.REGISTRATION_CONSENTS_SCREEN_VIEW](),
    ],
    [
      routes.step.phoneNumber.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.PHONE_NUMBER_INPUT_SCREEN_VIEW](),
    ],
    [
      routes.step.name.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.NAME_INPUT_SCREEN_VIEW](),
    ],
    [
      routes.step.internationalAddress.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.ADDRESS_INPUT_SCREEN_VIEW](),
    ],
    [
      routes.step.identityVerificationIntro.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.VERIFICATION_SPLASH_SCREEN_VIEW](),
    ],
    [
      routes.step.identityVerificationManualIdInfo.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.MANUAL_VERIFICATION_POP_UP_SCREEN_VIEW](),
    ],
    [
      routes.step.bankConnectionIntro.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.INCOME_VERIFICATION_SPLASH_SCREEN_VIEW](),
    ],
    [
      routes.step.otpVerificationSms.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.PHONE_CONFIRMATION_SCREEN_VIEW](),
    ],
    [
      routes.step.onboardingCompleted.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.SUCCESS_FINAL_SCREEN_SCREEN_VIEW](),
    ],
    [
      routes.step.emailPrivacyPolicy.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.EMAIL_INPUT_SCREEN_VIEW](),
    ],
    [
      routes.step.accountExists.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.ACCOUNT_EXISTS_SCREEN_VIEW](),
    ],
    [
      routes.step.otpVerificationEmail.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.EMAIL_OTP_SCREEN_VIEW](),
    ],
    [
      routes.step.password.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.SET_PASSWORD_SCREEN_VIEW](),
    ],
    [
      routes.step.countryOfBirth.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.COUNTRY_OF_BIRTH_SCREEN_VIEW](),
    ],
    [
      routes.step.personalId.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.ID_NUMBER_INPUT_SCREEN_VIEW](),
    ],
    [
      routes.step.educationType.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.EDUCATION_LEVEL_SCREEN_VIEW](),
    ],
    [
      routes.step.familyStatus.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.MARITAL_STATUS_SCREEN_VIEW](),
    ],
    [
      routes.step.familyChildren.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.NUMBER_OF_KIDS_SCREEN_VIEW](),
    ],
    [
      routes.step.incomeType.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.SOURCE_OF_INCOME_SCREEN_VIEW](),
    ],
    [
      routes.step.employmentType.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.AREA_OF_WORK_CZ_SCREEN_VIEW](),
    ],
    [
      routes.step.income.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.NET_INCOME_SCREEN_VIEW](),
    ],
    [
      routes.step.loanRepayment.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.LOAN_REPAYMENTS_SCREEN_VIEW](),
    ],
    [
      routes.step.expenses.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.EXPENSES_EXCLUDING_LOAN_REPAYMENTS_SCREEN_VIEW](),
    ],
    [
      routes.step.incomeVerificationCompleted.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.INCOME_VERIFICATION_SUCCESS_SCREEN_SCREEN_VIEW](),
    ],
    [
      routes.step.kontomatikLowIncomeStep.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.INCOME_VERIFICATION_TOO_LOW_ERROR_SCREEN_VIEW](),
    ],
    [
      routes.step.kontomatikNoIncomeStep.getPath({
        sessionId,
      }),
      events[
        ANALYTICS_EVENTS.INCOME_VERIFICATION_NO_INCOME_ERROR_SCREEN_VIEW
      ](),
    ],
    [
      routes.step.incomeVerificationBankAccountConnectionError.getPath({
        sessionId,
      }),
      events[
        ANALYTICS_EVENTS.INCOME_VERIFICATION_CANT_VERIFY_ERROR_SCREEN_VIEW
      ](),
    ],
    [
      routes.step.kontomatikErrorStep.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.INCOME_VERIFICATION_OTHER_ERROR_SCREEN_VIEW](),
    ],
    [
      routes.step.riskCheckProcessing.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.PROCESSING_MESSAGE_SCREEN_VIEW](),
    ],
    [
      routes.step.riskManualReviewStep.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.APPROVAL_WAITING_MESSAGE_SCREEN_VIEW](),
    ],
    [
      routes.step.crossCheckWarning.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.CROSS_CHECK_SCREEN_VIEW](),
    ],
    [
      routes.step.premiumAccountAgreements.getPath({
        sessionId,
      }),
      events[ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_SCREEN_VIEW](),
    ],
  ])
